import { createContext, useContext } from "react"

type LayoutType = "desktop" | "mobile"
export interface ILayoutContext {
  type: LayoutType
  palletteId: string
  mode: "dark" | "light"
}

export const LayoutContext = createContext<ILayoutContext>({
  type: "desktop",
  palletteId: "0",
  mode: "light"
})
LayoutContext.displayName = "LayoutContext"

export const useLayout = () => useContext(LayoutContext)
